<template>
    <div id="ig-side-menu-bar">
        <router-link to="/integrations/instagram" :class="{ active: selectedPage === 'integration' }" class="menu">
            {{ $t("chatbotv2.integration") }}
        </router-link>
        <router-link to="/integrations/instagram/users" :class="{ active: selectedPage === 'users' }" class="menu">
            {{ $t("chatbotv2.Users") }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: "InstagramMenu",
    props: {
        selectedPage: {
            type: String,
        },
        selectedSubPage: {
            type: String,
        },
    },
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>

<style lang="scss">
#ig-side-menu-bar {
    background-color: #f5f8fb;
    box-shadow: inset -7px -1px 25px -5px #d1dfec;
    padding: 20px 30px;
    height: 100%;

    .ant-menu-inline {
        border: none;
        background-color: transparent;

        li {
            .ant-menu-submenu-title {
                padding: 0 !important;
                margin: 0 !important;

                i {
                    display: none;
                }
            }

            ul {
                background-color: transparent !important;

                .ant-menu-item {
                    padding-left: 0px !important;
                }
            }
        }
    }

    .menu {
        word-wrap: break-word;
        color: #22272d;
        max-width: 100%;
        padding: 5px 0;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3s;
        display: block;

        &:hover {
            color: #008aff;
            opacity: 0.8;
        }

        &.active {
            color: #008aff;
            opacity: 0.8;
        }
    }

    .sub-menu {
        margin-left: 1rem;
        font-weight: 400;
        padding: 0;

        &.active {
            color: #008aff;
            opacity: 0.8;
        }

        &.hidden {
            display: none;
        }
    }

    //.router-link-active {
    //    color: #008aff;
    //    opacity: 0.8;
    //}
}
</style>
